<template>
  <BaseToggle
    v-model:is-checked="isExchangePossible"
    label="Kein Austausch möglich"
    test-id="failedMountAttempt"
    :is-inverted="true"
  />
  <BaseDropdown
    v-if="!isExchangePossible"
    v-model:selection="failedExchangeAttemptReason"
    label="Grund für keine Montage"
    dropdown-text="Grund wählen"
    test-id="failedMountAttemptReason"
    :options-list="failedExchangeAttemptReasons"
    :numbered="true"
  />
  <BaseTextarea
    v-if="!isExchangePossible"
    v-model:input-text="failedExchangeAttemptNote"
    test-id="failedMountAttemptNote"
    label="Bemerkung"
    class="mb-3"
  />

  <BaseSection v-if="!isExchangePossible" heading="Foto">
    <BaseInformation
      information-text="Zur Veranschaulichung des Grundes, weshalb das Gerät nicht montiert werden kann, nehmen Sie bitte ein Foto auf."
    />
    <Checkbox
      v-model:checked="isImageNotAllowedChecked"
      label="Nutzer verweigert Foto"
      checkbox-id="failedExchangeAttemptCheckbox"
    />
    <ImageCapture
      v-if="!isExchangePossible"
      ref="imageCaptureRef"
      class="mt-4"
      :object-id="installationPoint.id"
      :object-type="ImageObjectType.UNMOUNTED_DEVICE"
    />
  </BaseSection>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import BaseToggle from '@/components/UI/Switch/BaseToggle.vue';
import BaseTextarea from '@/components/UI/Note/BaseTextarea.vue';
import Checkbox from '@/components/UI/Checkbox/Checkbox.vue';
import BaseInformation from '@/components/UI/Hint/BaseInformation.vue';
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import ImageCapture, {
  ImageCaptureRef,
} from '@/components/Forms/DeviceFormComponents/ImageCapture.vue';
import { ImageObjectType } from '@/models/Image';
import BaseDropdown from '@/components/UI/Dropdown/BaseDropdown.vue';
import { InstallationPoint } from '@/models/installationPoint/InstallationPoint';
import { noTKDPossibleReasons } from '@/enums/device';

const isExchangePossible = defineModel<boolean>('isExchangePossible', {
  required: true,
});

const installationPoint = defineModel<InstallationPoint>('installationPoint', {
  required: true,
});

const failedExchangeAttemptReason = defineModel<string>(
  'failedExchangeAttemptReason',
  { required: true }
);
const failedExchangeAttemptNote = defineModel<string>(
  'failedExchangeAttemptNote'
);

const isImageNotAllowedChecked = ref(false);
const imageCaptureRef = ref<ImageCaptureRef | null>(null);

const failedExchangeAttemptReasons = computed(() => noTKDPossibleReasons);

defineExpose({
  isFormValid: computed(
    () =>
      failedExchangeAttemptReason.value &&
      failedExchangeAttemptNote.value &&
      (imageCaptureRef.value?.hasImage || isImageNotAllowedChecked.value)
  ),
  saveImage: () => imageCaptureRef.value?.saveImage(),
});
</script>
